/**
 * Constants and configuration for MapLocationPicker component
 */

import { DEFAULT_LOCATION } from "../../../utils/constants";

export const DEFAULT_CENTER = {
  lat: DEFAULT_LOCATION.lat,
  lng: DEFAULT_LOCATION.lng,
};

export const MAP_CONFIG = {
  DEFAULT_ZOOM: 13,
  SEARCH_ZOOM: 15,
  SEARCH_LIMIT: 1,
} as const;

export const TILE_LAYER_CONFIG = {
  URL: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  ATTRIBUTION:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
} as const;

export const NOMINATIM_CONFIG = {
  BASE_URL: "https://nominatim.openstreetmap.org",
  SEARCH_ENDPOINT: "/search",
  REVERSE_ENDPOINT: "/reverse",
  FORMAT: "json",
  ADDRESS_DETAILS: 1,
} as const;
